import React, { useState } from 'react';
import empresa1 from '../assets/images/empresa1.png';
import empresa2 from '../assets/images/empresa2.png';
import empresa3 from '../assets/images/empresa3.png';
import empresa4 from '../assets/images/empresa4.png';

function Xp() {
  const [modalAbierto, setModalAbierto] = useState(null);

  const abrirModal = (id) => setModalAbierto(id);
  const cerrarModal = () => setModalAbierto(null);

  const experiencias = [
    {
      id: 1,
      titulo: "Ingeniera de desarrollo",
      empresa: "Spidersoftware",
      periodo: "2024 - Hoy",
      detalles:  `
• Diseño e implementación de soluciones según requerimientos del cliente.
• Desarrollo de interfaces funcionales, intuitivas y optimizadas.
• Pruebas, integración y mantenimiento para garantizar rendimiento y escalabilidad.`,
      imagen: empresa1,
    },
    {
      id: 2,
      titulo: "Desarrolladora Freelance / Consultora IT",
      empresa: "Upwork",
      periodo: "2023",
      detalles: `
• Desarrollo y diseño de soluciones personalizadas para diversos clientes.
• Optimización de procesos internos mediante tecnología.
• Atención al detalle en estética y funcionalidad.`,
      imagen: empresa2,
    },
    {
      id: 3,
      titulo: "Capacitadora de Personal / Interfaz Móvil POS",
      empresa: "Cluvi",
      periodo: "Jul 2022 - Jun 2023",
      detalles: `
• Capacitación técnica a restaurantes para uso de apps móviles.
• Reducción de errores y mejora del 90% en adopción tecnológica.
• Diseño de estrategias formativas efectivas.`,
      imagen: empresa3,
    },
    {
      id: 4,
      titulo: "Diseñadora de Páginas Web",
      empresa: "System On",
      periodo: "2022 - 2023",
      detalles: `
• Desarrollo de páginas web orientadas a experiencia del usuario.
• Implementación de diseño responsive y funcionalidad optimizada.`,
      imagen: empresa4,
    },
  ];
  

  return (
    <section id="experiencia-section" className="sobremi-section">
      <video className="sobremi-video" autoPlay muted loop playsInline>
        <source src="/videos/teddy.mp4" type="video/mp4" />
        Tu navegador no soporta el video HTML5.
      </video>

      <div className="sobremi-content">
        <div className="sobremi-box">
          <h2 className="sobremi-titulo">Experiencia</h2>
          <div className="experiencia-grid">
            {experiencias.map((exp) => (
              <div
                key={exp.id}
                className="experiencia-card"
                onClick={() => abrirModal(exp.id)}
              >
                <h3>{exp.titulo}</h3>
                <p>{exp.empresa}</p>
                <span>{exp.periodo}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {experiencias.map((exp) =>
        modalAbierto === exp.id ? (
          <div key={exp.id} className="modal-overlay" onClick={cerrarModal}>
            <div className="modal-contenido" onClick={(e) => e.stopPropagation()}>
              <button className="modal-cerrar" onClick={cerrarModal}>✖</button>
              <h3>{exp.titulo}</h3>
                <img
                src={exp.imagen}
                alt={exp.empresa}
                style={{
                    width: '100%',
                    maxHeight: '200px',
                    objectFit: 'contain',
                    borderRadius: '10px',
                    margin: '10px 0'
                }}
                />
                <p><strong>{exp.empresa}</strong> — {exp.periodo}</p>
                <pre>{exp.detalles}</pre>

            </div>
          </div>
        ) : null
      )}
    </section>
  );
}

export default Xp;
